/**
 * useMediaConfigSearch
 */

import useMediaConfig from './useMediaConfig';
import { MEDIA_CONFIG_CONTEXT } from '../../utils/constants';

const useMediaConfigSearch = () => useMediaConfig(MEDIA_CONFIG_CONTEXT.search);

export default useMediaConfigSearch;
